// ==============================|| OVERRIDES - CHECKBOX ||============================== //

export default function Checkbox() {
	return {
		MuiCheckbox: {
			styleOverrides: {
				root: {
					color: '#1890ff',
					'&.Mui-checked': {
						color: '#0F172A',
					},
				},
			},
		},
	};
}
